/**
 * Atajos para abrir paneles desde cualquier parte de la app sin pasarse
 * callbacks por media docena de componentes.
 *
 * Ya no hay prueba gratis ni registro público (2026-10-08, decisión de
 * Antonio del 30-sep): las cuentas las abre TerraKairos desde la consola.
 */

/** Abre el panel de la lista de resultados (p.ej. al terminar la bienvenida de una cuenta nueva). */
export function openResultsList(): void {
  window.dispatchEvent(new CustomEvent('tk:open-list'));
}

/** Abre "Mi plan" (con las opciones para mejorar) desde cualquier parte de la app. */
export function openPlanPanel(): void {
  window.dispatchEvent(new CustomEvent('tk:open-plan'));
}

/** Abre el modal de inicio de sesión. */
export function openLogin(): void {
  window.dispatchEvent(new CustomEvent('tk:open-login'));
}
